import React from 'react';

import './styles.scss';
import MaintenanceImg from 'assets/images/empty/Maintenance.png';

const Maintenance = () => {
  return (
    <div className="maintenance-page">
      <div>
        <div className="coming-soon">We'll Be Back Soon!</div>
        <div>
          <p>Turn It Blue Ads is undergoing scheduled maintenance.</p>
        </div>
        <div>
          <p>
            <i>
              We apologize for the extended delay. This is significant
              performance upgrade to the platform prior to Election Day, and is
              taking a bit longer than expected.
            </i>
          </p>
          <p>
            Please check back or contact{' '}
            <a href="mailto:success@turnitbluedigital.com">
              success@turnitbluedigital.com
            </a>{' '}
            for any urgent needs.
          </p>
        </div>
      </div>
      <img src={MaintenanceImg} />
    </div>
  );
};

export default Maintenance;
